import { defineComponent as _defineComponent } from 'vue'
import DateConfirmed from '@/components/svg/date-confirmed.svg?inline';
import DateCancelled from '@/components/svg/date-cancelled.svg?inline';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import BCXRadio from '@/components/molecules/forms/BCXRadio.vue';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import { ref, computed, watch } from 'vue';
import useI18n from '@/mixins/useI18n';
import useMeetingScheduler from '@/components/meeting-scheduler/composables/useMeetingScheduler';
import useUser from '@/mixins/useUser';
import MarvinSleeping from '@/components/svg/marvin/marvin_sleeping.svg?inline';
import { TimeSlotDetail } from '@/models/MeetingScheduler';
import MeetingCaption from '@/components/meeting-scheduler/components/MeetingCaption.vue';
import MeetingSlotLabel from '@/components/meeting-scheduler/components/MeetingSlotLabel.vue';
import MeetingSlotConflict from '@/components/meeting-scheduler/components/MeetingSlotConflict.vue';
import useConflictPopover from '@/components/meeting-scheduler/composables/useConflictPopover';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingDetail',
  setup(__props) {

const { t } = useI18n();
const { userId } = useUser('self');

const {
  meetingDetail,
  events,
  isMeetingDetailLoading
} = useMeetingScheduler();

const isDetailHelpEnabled = false;
const isHelpOpen = ref<boolean>(false);
const isCreator = computed(() => meetingDetail.value?.creator.userId === userId.value);
const isConfirmed = computed(() => meetingDetail.value?.status === 'CONFIRMED');
const isPending = computed(() => meetingDetail.value?.status === 'PENDING');
// Cancelled / expired meetings (e.g. reached from search) share one display: red X + own label.
const isInvalid = computed(() => meetingDetail.value?.status === 'CANCELLED' || meetingDetail.value?.status === 'EXPIRED');
const invalidStatusKey = computed(() => `meeting.detail.status-${meetingDetail.value?.status?.toLowerCase() ?? ''}`);
const otherPartyId = computed(() => (isCreator.value ? meetingDetail.value?.participant.userId : meetingDetail.value?.creator.userId));
const selectedSlot = ref<TimeSlotDetail | null>(null);

const isPast = computed(() => !!meetingDetail.value?.timeSlots.some((slot) => dayjs(slot.start).isBefore(dayjs())));
const { close: closeConflictPopover } = useConflictPopover();

// Reset the slot selection / conflict popover whenever a different meeting is shown, otherwise a
// stale selection would keep the accept button enabled and submit the wrong timeSlotId.
watch(meetingDetail, () => {
  selectedSlot.value = null;
  closeConflictPopover();
});

return { __sfc: true,t, userId, meetingDetail, events, isMeetingDetailLoading, isDetailHelpEnabled, isHelpOpen, isCreator, isConfirmed, isPending, isInvalid, invalidStatusKey, otherPartyId, selectedSlot, isPast, closeConflictPopover, DateConfirmed, DateCancelled, BCXUserBanner, BCXButton, BCXRadio, BCXHelpTextTriggerIcon, BCXInfoCollapsible, MarvinSleeping, MeetingCaption, MeetingSlotLabel, MeetingSlotConflict }
}

})